/*
 * Events functions, will get pushed very early.
 */

ckdc.events = {
  /**
   * View promotion standard event.
   *
   * https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#view_promotion
   *
   * Event will be sent to both GA4 and UA analytics.
   *
   * @param string action Promotion action: 'popup', ...
   * @param string name   Promotion item name: 'feature-lock', ...
   *
   * @return bool Always returns true to allow usage in onclick handlers.
   */
  viewPromotion: function( action, name ) {
    var item = {
      item_name: name
    };
    ckdc.events.ua( 'view_promotion', action, name );
    ckdc.events.ga4( 'view_promotion', action, { items: [ item ] } );
    return true;
  },

  /**
   * Select promotion standard event.
   *
   * https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#select_promotion
   *
   * Event will be sent to both GA4 and UA analytics.
   *
   * @param string action  Promotion action: 'popup', ...
   * @param string name    Promotion item name: 'feature-lock', ...
   * @param string variant Optional. Promotion variant selected: 'checkout', ...
   *
   * @return bool Always returns true to allow usage in onclick handlers.
   */
  selectPromotion: function( action, name, variant ) {
    var item = {
      item_name: name
    };
    if ( typeof variant !== 'undefined' ) {
      item.item_variant = variant;
    }
    ckdc.events.ua( 'select_promotion', action, name );
    ckdc.events.ga4( 'select_promotion', action, { items: [ item ] } );
    return true;
  },

  /**
   * Send a GA4 recipe event.
   * @param string action Event action.
   * @param string id     Recipe ID.
   * @returns true, for onClick use.
   */
  recipe: function ( action, id ) {
    return ckdc.events.ga4( 'recipe', action, id && {id: id} );
  },

  /**
   * Send a GA4 video event.
   * @param string action Event action.
   * @param string id     Video post ID.
   * @returns true, for onClick use.
   */
  video: function ( action, id ) {
    return ckdc.events.ga4( 'video', action, id && {id: id} );
  },

  /**
   * Send favorite event.
   * @param string postType Type of post being favorited.
   * @param string postId ID of the item being favorited.
   * @returns true
   */
  favorite: function ( postType, postId ) {
    if ( postType === 'kd_recipe' ) {
      return ckdc.events.recipe( 'recipe_favorite', postId );
    }

    if ( postType === 'kd_video' ) {
      return ckdc.events.video( 'video_favorite', postId );
    }

    return true
  },

  /**
   * Send GA4 event.
   *
   * @param string event GA4 event name.
   * @param string action Event action.
   * @param object payload Event parameters.
   *
   * @returns true
   */
  ga4: function ( event, action, payload ) {
	/* Note 'event' is GTM event name and 'event_name' is GA4 event name. */
    return ckdc.events.gtm( {
      event: 'GA4_EVENT',
      event_name: event,
      event_action: action,
      event_payload: payload && JSON.stringify(payload), /* Pass the payload stringified in order to make it parsable by Big Query. */
    } );
  },

  /**
   * Send UA Google Analytics event.
   *
   * Requires at least 3 arguments.
   *
   * @param string category Event category. Typically the object that was interacted with.
   * @param string action   Event action. The type of interaction.
   * @param string label    Optional. Event label. Useful for categorizing events.
   * @param int    Value    Optional. Event value.
   *
   * @return bool Always returns true to allow usage in onclick handlers.
   */
  ua: function( category, action, label, value ) {
    return ckdc.events.gtm( {
      event: 'UA_EVENT',
      event_category: category,
      event_action: action,
      event_label: label,
      event_value: value,
    } );
  },

  /**
   * Push a GTM event object to dataLayer.
   *
   * @param object event Event object. 'event' field is required.
   *
   * @return bool Always returns true to allow usage in onclick handlers.
   */
  gtm: function( event ) {
    if ( typeof event !== 'object' || ! event.hasOwnProperty( 'event' ) ) {
      console.log( 'Invalid event argument', event );
    } else if ( ckdc.environment !== 'PRODUCTION' ) {
      console.log( event );
    } else {
      dataLayer.push( event );
    }
    return true;
  },

  /**
   * Log obsolete functions
   */
  obsoleteFunction: function ( fn ) {
    console.log( 'Call to obsolete function ' + fn );
  }
}


/*
 * Old obsolete functions: keep for a bit to see if we hit any loggs!
 */

ckdc.event = function() {
  ckdc.events.obsoleteFunction( 'ckdc.event' );
  return ckdc.events.ua( arguments[0], arguments[1], arguments[2] );
}

ckdc.ga4Event = function( event, action, payload ) {
  /* Used in multiple places outside this repo, so just do it and don't warn. */
  return ckdc.events.ga4( event, action, payload );
}

ckdc.recipeEvent = function ( action, id ) {
  ckdc.events.obsoleteFunction( 'ckdc.recipeEvent' );
  return ckdc.events.recipe( action, id );
}

ckdc.videoEvent = function ( action, id ) {
  ckdc.events.obsoleteFunction( 'ckdc.videoEvent' );
  return ckdc.events.video( action, id );
}

ckdc.favoriteEvent = function ( postType, postId ) {
  ckdc.events.obsoleteFunction( 'ckdc.favoriteEvent' );
  return ckdc.events.favorite( postType, postId );
}
